"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _media = _interopRequireDefault(require("../utils/media"));

var _units = _interopRequireDefault(require("../utils/units"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  align-self: stretch;\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin: ", " ", ";\n    ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var styles = function styles(_ref) {
  var t = _ref.theme,
      css = _ref.css,
      rootSize = _ref.rootSize;
  var vertical = t.gap / 2;
  var horizontal = -1 * vertical;
  if (t.gutter === 0) vertical *= -1;else if (t.gutter) vertical = t.gutter;
  return css(_templateObject(), (0, _units["default"])({
    param: vertical,
    rootSize: rootSize
  }), (0, _units["default"])({
    param: horizontal,
    rootSize: rootSize
  }), t.extendCss);
};

var _default = _styledComponents["default"].div(_templateObject2(), function (_ref2) {
  var theme = _ref2.coolgrid;
  return (0, _media["default"])({
    styles: styles,
    css: _styledComponents.css
  })({
    theme: theme
  });
});

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/Row/styled.js
// module id = 235
// module chunks = 0